export const toDateInput = (dateString?: null | string) => {
	if (!dateString) return '';

	return new Date(dateString).toISOString().split('T')[0]; // "yyyy-MM-dd"
};
